module.exports = __webpack_public_path__ + "img/_3.95606615.png";